import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        // clientId: "6a2b82fb-1dec-4a8a-b674-189dd534dbcb", // This is the ONLY mandatory field that you need to supply.
        // authority: "https://login.microsoftonline.com/0344d8df-8cfc-43f0-9d42-328d7e7ff4d6", // Replace with your tenant ID or use 'common' for multi-tenant

        //Local
        clientId: window.configuration.CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
        authority: `https://login.microsoftonline.com/${window.configuration.TENANT_ID}`, // Replace with your tenant ID or use 'common' for multi-tenant
        redirectUri: window.configuration.AUTH_REDIRECT_URL, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: window.configuration.POST_LOGOUT_REDIRECT_URL, // Indicates the page to navigate after logout.

        //Local Dev
        // clientId: "5e94b474-f359-451d-95ac-1c6f360c1633", // This is the ONLY mandatory field that you need to supply.
        // authority: "https://login.microsoftonline.com/ed2d4aa0-93e5-4b9f-aec4-eeca68ce073d", // Replace with your tenant ID or use 'common' for multi-tenant
        // redirectUri: "https://lumosmigdev.lateetudservices.com:8653", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        // postLogoutRedirectUri: "https://lumosmigdev.lateetudservices.com:8653/Login", // Indicates the page to navigate after logout.

        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
        ValidityState: false
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequestConfig = {
    scopes: ["User.Read", "Group.Read.All"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};